import angular from "angular";
import LibraryCostsPageComponent from "./library-costs-page/library-costs-page.component";
import ImportCostsCsvModalComponent from "./import-costs-csv-modal/import-costs-csv-modal";
import CostModalComponent from "./cost-modal/cost-modal";
import SelectCostModalComponent from "./select-cost-modal/select-cost-modal-controller";
import CostFormComponent from "../library-costs/cost-form/cost-form";

const LibraryCostsModule = angular
  .module("modules.libraryCosts", [])
  .component("libraryCostsPage", LibraryCostsPageComponent)
  .component("importCostsCsvModal", ImportCostsCsvModalComponent)
  .component("costForm", CostFormComponent)
  .component("costModal", CostModalComponent)
  .component("selectCostModal", SelectCostModalComponent);

export default LibraryCostsModule;
